import { render, staticRenderFns } from "./contactform.vue?vue&type=template&id=38479277"
import script from "./contactform.vue?vue&type=script&lang=js"
export * from "./contactform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports